// extracted by mini-css-extract-plugin
export default {"products":"Mt-z","card":"Nt-z","oosMessaging":"Ot-z"};